import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { BulkActionComponent } from './bulk-action.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    declarations: [
        BulkActionComponent
    ],
    entryComponents: [
        BulkActionComponent
    ],
    exports: [
        BulkActionComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule
    ],
})
export class BulkActionModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            BulkActionComponent
        ]);
    }
}
